import { render } from "./CollectionCreatorPassport.vue?vue&type=template&id=6fae26d2"
import script from "./CollectionCreatorPassport.vue?vue&type=script&lang=js"
export * from "./CollectionCreatorPassport.vue?vue&type=script&lang=js"

import "./CollectionCreatorPassport.vue?vue&type=style&index=0&id=6fae26d2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__